import React, { useEffect, useState } from "react";
import Header from "../../Header";
import "../../assets/css/alie.css";
import { useLocation, useHistory } from "react-router-dom";

import moment from "moment";
import Pagination from "react-js-pagination";
import DateRangePicker from "react-bootstrap-daterangepicker";

const getMergedIntervals = (joiningInfos) => {
    const validIntervals = (joiningInfos || [])
        .filter(info => info.start_time && info.end_time)
        .map(info => ({
            start: moment(info.start_time),
            end: moment(info.end_time)
        }))
        .filter(({ start, end }) => start.isBefore(end))
        .sort((a, b) => a.start - b.start);

    const merged = [];
    for (let interval of validIntervals) {
        if (merged.length === 0) {
            merged.push({ ...interval });
        } else {
            const last = merged[merged.length - 1];
            if (interval.start.isSameOrBefore(last.end)) {
                last.end = moment.max(last.end, interval.end);
            } else {
                merged.push({ ...interval });
            }
        }
    }

    return merged.map(({ start, end }) => ({
        start,
        end,
        durationHours: parseFloat(moment.duration(end.diff(start)).asHours().toFixed(2))
    }));
};

const EmployeeActivityInsightsDetails = () => {
    const location = useLocation();

    const history = useHistory();

    const [meetingLogs, setMeetingLogs] = useState([]);

    const [usageLogs, setUsageLogs] = useState([]);

    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const [selectedLog, setSelectedLog] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const perPage = 10;

    const getQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            email: params.get("email"),
            start_date: params.get("start_date"),
            end_date: params.get("end_date"),
        };
    };

    const { email, start_date, end_date } = getQueryParams();

    useEffect(() => {
        const fetchDetails = async () => {
            if (!email || !start_date || !end_date) return;
            setLoading(true);
            try {
                const url = `${process.env.REACT_APP_CRM}/admin/employee/logsbydate?email=${encodeURIComponent(email)}&start_date=${start_date}&end_date=${end_date}`;
                const res = await fetch(url);
                const result = await res.json();
                setMeetingLogs(result.meeting_logs || []);
                setUsageLogs(result.usage_logs || []);
            } catch (err) {
                console.error("Failed to fetch meeting logs", err);
                setMeetingLogs([]);
                setUsageLogs([]);
            } finally {
                setLoading(false);
            }
        };

        fetchDetails();
    }, [email, start_date, end_date]);

    const handleDateApply = (event, picker) => {
        const newStart = moment(picker.startDate).format("YYYY-MM-DD");
        const newEnd = moment(picker.endDate).format("YYYY-MM-DD");


        history.push(`/employees/productivity/details?email=${encodeURIComponent(email)}&start_date=${newStart}&end_date=${newEnd}`);
    };

    const filteredLogs = meetingLogs.filter((log) =>
        (log.title || "").toLowerCase().includes(searchQuery.toLowerCase())
    );

    const paginatedLogs = filteredLogs.slice(
        (currentPage - 1) * perPage,
        currentPage * perPage
    );

    const totalMeetings = filteredLogs.length;

    const totalHours = filteredLogs.reduce((sum, log) => sum + (log.hours_spent || 0), 0);

    const totalEmail = usageLogs.reduce((sum, log) => sum + (log.emails_sent || 0), 0);

    const totalMinsLate = usageLogs.reduce((sum, log) => sum + (log.total_minutes_late || 0), 0);

    const avgLateMins =
        totalMeetings > 0
            ? totalMinsLate / totalMeetings
            : 0;

    const modalBackdropStyle = {
        position: "fixed",
        top: 0, left: 0,
        width: "100%", height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex", justifyContent: "center", alignItems: "center",
        zIndex: 999,
    };

    const modalContentStyle = {
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        maxWidth: "600px",
        width: "90%",
        maxHeight: "80%",
        overflowY: "auto",
    };

    return (
        <div>
            <Header brecum_name="AI" brecum_page="Activity Insights Details" />
            <div className="right_col">
                <div className="ticket_list">
                    <div className="customer-wrap">
                        <div className="page-top" style={{ paddingRight: "0px" }}>
                            <div className="container" style={{
                                paddingRight: "5px"
                            }}>
                                <div className="row align-items-center mb-3">
                                    <div className="col-md-9">
                                        <div class="d-flex align-items-center">
                                            <h2>Daily Activity Insights</h2><span class="badge-blue">{email}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-3" style={{ paddingRight: "20px" }}>
                                        <DateRangePicker
                                            initialSettings={{
                                                startDate: moment(start_date),
                                                endDate: moment(end_date),
                                                showDropdowns: true,
                                                autoUpdateInput: false,
                                                linkedCalendars: false,
                                            }}
                                            onApply={handleDateApply}
                                        >
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={
                                                    moment(start_date).format("MMM D, YYYY") +
                                                    " - " +
                                                    moment(end_date).format("MMM D, YYYY")
                                                }
                                            />
                                        </DateRangePicker>
                                    </div>
                                </div>

                                {loading ? (
                                    <p>Loading...</p>
                                ) : filteredLogs.length === 0 ? (
                                    <p>No meeting logs found for this range.</p>
                                ) : (
                                    <div className="table-wrap" style={{ padding: "1em" }}>

                                        <div className="section">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Email Sent</th>
                                                        <th>Meeting Attended</th>
                                                        <th>Hours Spent</th>
                                                        <th>Total Minutes Late</th>
                                                        <th>Avg Minutes Late</th>
                                                    </tr>
                                                </thead>


                                                <tbody>
                                                    {usageLogs.map((log, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {log.date
                                                                    ? log.date
                                                                    : ""}
                                                            </td>
                                                            <td>{log.emails_sent ? log.emails_sent : "-"}</td>
                                                            <td>{log.meetings_attended ? log.meetings_attended : "-"}</td>
                                                            <td>{log.total_hours_spent ? log.total_hours_spent : "-"}</td>
                                                            <td>{log.total_minutes_late ? log.total_minutes_late : "-"}</td>
                                                            <td>{log.average_minutes_late ? log.average_minutes_late : "-"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>

                                                <tfoot>
                                                    <tr>
                                                        <td>Total</td>
                                                        <td>{totalEmail}</td>
                                                        <td>{totalMeetings}</td>
                                                        <td>{totalHours.toFixed(2)}</td>
                                                        <td>{totalMinsLate.toFixed(2)}</td>
                                                        <td>{avgLateMins.toFixed(2)}</td>
                                                    </tr>
                                                </tfoot>

                                            </table>
                                        </div>

                                        <hr />

                                        <div className="section">
                                            <div className="row align-items-center mb-3" style={{ paddingBottom: "1em" }}>
                                                <div className="col-md-9">
                                                    <h2>Daily Meeting Logs</h2>
                                                </div>

                                                <div className="col-md-3" style={{
                                                    paddingRight: "10px"
                                                }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search by meeting title"
                                                        value={searchQuery}
                                                        onChange={(e) => {
                                                            setSearchQuery(e.target.value);
                                                            setCurrentPage(1);
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <table>

                                                <thead>
                                                    <tr>
                                                        <th>Title</th>
                                                        <th>Start Time</th>
                                                        <th>End Time</th>
                                                        <th>Joined Late (mins)</th>
                                                        <th>Hours Spent</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paginatedLogs.map((log, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <a
                                                                    onClick={() => {
                                                                        setSelectedLog(log);
                                                                        setShowModal(true);
                                                                    }}
                                                                >
                                                                    {log.title.length > 50 ? log.title.slice(0, 50) + "..." : log.title}
                                                                </a>
                                                            </td>

                                                            <td>{log.start_time ? moment(log.start_time).format("MMM D, YYYY HH:mm") : "-"}</td>
                                                            <td>{log.end_time ? moment(log.end_time).format("MMM D, YYYY HH:mm") : "-"}</td>
                                                            <td>{log.joined_late_mins !== undefined && log.joined_late_mins !== null ? log.joined_late_mins : "-"}</td>
                                                            <td>{typeof log.hours_spent === "number" ? log.hours_spent.toFixed(2) : "0.00"}</td>
                                                        </tr>


                                                    ))}
                                                </tbody>
                                            </table>
                                            {filteredLogs.length > perPage && (
                                                <div className="d-flex justify-content-between align-items-center mt-3">
                                                    <p className="mb-0">
                                                        Showing {(currentPage - 1) * perPage + 1} to{" "}
                                                        {Math.min(currentPage * perPage, filteredLogs.length)} of {filteredLogs.length} entries
                                                    </p>
                                                    <div className="mu-pagination">
                                                        <Pagination
                                                            activePage={currentPage}
                                                            itemsCountPerPage={perPage}
                                                            totalItemsCount={filteredLogs.length}
                                                            pageRangeDisplayed={5}
                                                            onChange={setCurrentPage}
                                                            itemClass="page-item"
                                                            linkClass="page-link"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>





                                    </div>
                                )}

                                <div>

                                    {showModal && selectedLog && (
                                        <div className="modal-backdrop" style={modalBackdropStyle}>
                                            <div className="modal-content" style={modalContentStyle}>
                                                <h4>{selectedLog.title}</h4>

                                                {(() => {
                                                    const intervals = getMergedIntervals(selectedLog.joining_infos || []);
                                                    const totalHours = intervals.reduce((sum, i) => sum + i.durationHours, 0).toFixed(2);

                                                    // Tag each joining_info with corresponding merged interval
                                                    const taggedInfos = (selectedLog.joining_infos || []).map((info) => {
                                                        const start = moment(info.start_time);
                                                        const end = moment(info.end_time);

                                                        let matchedInterval = null;
                                                        for (let intvl of intervals) {
                                                            if (start.isSameOrAfter(intvl.start) && end.isSameOrBefore(intvl.end)) {
                                                                matchedInterval = intvl;
                                                                break;
                                                            }
                                                        }

                                                        return {
                                                            ...info,
                                                            mergedStart: matchedInterval ? matchedInterval.start : null,
                                                            mergedEnd: matchedInterval ? matchedInterval.end : null,
                                                        };
                                                    });

                                                    return (
                                                        <div>
                                                            <p><strong>Total Hours Spent:</strong> {totalHours} hrs</p>
                                                            <table className="table table-bordered">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Start Time</th>
                                                                        <th>End Time</th>
                                                                        <th>Device</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {taggedInfos.map((info, i) => (
                                                                        <tr key={i}>
                                                                            <td>{moment(info.start_time).format("MMM D, YYYY HH:mm")}</td>
                                                                            <td>{moment(info.end_time).format("MMM D, YYYY HH:mm")}</td>
                                                                            <td>{info.device_type}</td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                                <tfoot>
                                                                    <tr>
                                                                        <td colSpan="4">
                                                                            <strong>Merged Intervals Summary:</strong>
                                                                            <ol style={{ marginBottom: 0, marginTop: '4px' }}>
                                                                                {intervals.map((interval, i) => (
                                                                                    <li key={i}>
                                                                                        {interval.start.format("MMM D, YYYY HH:mm")} – {interval.end.format("HH:mm")}
                                                                                        &nbsp; ({interval.durationHours.toFixed(2)} hrs)
                                                                                    </li>
                                                                                ))}
                                                                            </ol>
                                                                        </td>
                                                                    </tr>
                                                                </tfoot>
                                                            </table>
                                                        </div>
                                                    );
                                                })()}

                                                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeActivityInsightsDetails;



// WEBPACK FOOTER //
// ./src/components/hrAdmin/EmployeeActivityInsightsDetails.js